import {DrugsCategoryDrawer} from '@/modules/basic-data/categories/components/drugs-category-drawer/drugs-category-drawer'
import {drawer} from '@cypro/ui/components'
import {DrugsCategoryProvider} from '@/shared/contexts/drugs-category'
import {DrugsCategory} from '@cypro/engine/schema'
import {Suspense} from 'react'

export function getDrugsCategoryDrawerId(categoryId: string) {
  return `substance-category-drawer-${categoryId}`
}

export function openDrugsCategoryDrawer(category: DrugsCategory) {
  const id = getDrugsCategoryDrawerId(category.id)

  try {
    drawer.remove(id)
  } catch {}

  return drawer.open(id, {
    id,
    children: (
      <Suspense fallback={null}>
        {category && (
          <DrugsCategoryProvider category={category}>
            <DrugsCategoryDrawer />
          </DrugsCategoryProvider>
        )}
      </Suspense>
    ),
    contentProps: {
      'data-e2e': 'drugs-category-drawer',
    },
  })
}
